// Always import {h} from preact
import { h, render } from 'preact';
import TrialShop from '../components/TrialShop';

const altTargetNode = document.querySelector('.trial-shop-section');

if (altTargetNode) {
  render(
    <TrialShop
      products={window.preactShopProducts}
      brand={window.preactShopBrand}
      optionSubText={window.preactShopOptionSubText}
      brandAlt={window.preactShopBrandAlt}
    />,
    altTargetNode
  );
}
